/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ue_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Text is percent-encoded as UTF-8, so accents, emoji and CJK characters encode and decode correctly.`)
};

const es_ue_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. El texto se codifica en porcentaje como UTF-8, por lo que los acentos, emoji y caracteres CJK se codifican y decodifican correctamente.`)
};

const de_ue_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Text wird als UTF-8 mit Prozentzeichen kodiert, daher werden Umlaute, Emojis und CJK-Zeichen korrekt kodiert und dekodiert.`)
};

const nl_ue_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Tekst wordt percent-gecodeerd als UTF-8, dus accenten, emoji's en CJK-karakters worden correct gecodeerd en gedecodeerd.`)
};

const fr_ue_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Le texte est encodé en pourcentage en UTF-8, donc les accents, les emoji et les caractères CJK s'encodent et se décodent correctement.`)
};

const it_ue_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Il testo viene codificato in percentuale come UTF-8, quindi gli accenti, gli emoji e i caratteri CJK vengono codificati e decodificati correttamente.`)
};

const pt_br2_ue_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. O texto é codificado por porcentagem como UTF-8, portanto acentos, emoji e caracteres CJK são codificados e decodificados corretamente.`)
};

const pt_ue_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. O texto é codificado em percentual como UTF-8, portanto os acentos, emojis e caracteres CJK são codificados e descodificados corretamente.`)
};

const ja_ue_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。テキストはUTF-8 としてパーセント エンコードされるため、アクセント、絵文字、CJK文字は正しくエンコードおよびデコードされます。`)
};

const zh_ue_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。文本会以 UTF-8 进行百分号编码，因此重音符号、表情符号和中日韩（CJK）字符都能正确编码和解码。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ue_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ue_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ue_faq2_a", locale)
	if (locale === "en") return en_ue_faq2_a(inputs)
	if (locale === "es") return es_ue_faq2_a(inputs)
	if (locale === "de") return de_ue_faq2_a(inputs)
	if (locale === "nl") return nl_ue_faq2_a(inputs)
	if (locale === "fr") return fr_ue_faq2_a(inputs)
	if (locale === "it") return it_ue_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_ue_faq2_a(inputs)
	if (locale === "pt") return pt_ue_faq2_a(inputs)
	if (locale === "ja") return ja_ue_faq2_a(inputs)
	return zh_ue_faq2_a(inputs)
};